export interface DuaData {
  title: string;
  arabicText: string;
  translation: string;
}

const DUAS = [
  {
    title: "Morning Remembrance",
    arabicText: "أَصْبَحْنَا وَأَصْبَحَ الْمُلْكُ لِلَّهِ",
    translation: "We have reached the morning, and at this very time unto Allah belongs all sovereignty."
  },
  {
    title: "Protection from Evil",
    arabicText: "بِسْمِ اللَّهِ الَّذِي لَا يَضُرُّ مَعَ اسْمِهِ شَيْءٌ فِي الْأَرْضِ وَلَا فِي السَّمَاءِ",
    translation: "In the name of Allah, with whose name nothing on earth or in heaven can cause harm."
  },
  {
    title: "Before Eating",
    arabicText: "بِسْمِ اللَّهِ",
    translation: "In the name of Allah."
  },
  {
    title: "After Eating",
    arabicText: "الْحَمْدُ لِلَّهِ الَّذِي أَطْعَمَنَا وَسَقَانَا",
    translation: "Praise be to Allah who has fed us and given us drink."
  },
  {
    title: "Before Sleeping",
    arabicText: "بِاسْمِكَ اللَّهُمَّ أَمُوتُ وَأَحْيَا",
    translation: "In Your name, O Allah, I die and I live."
  }
];

export const getRandomDua = (): DuaData => {
  return DUAS[Math.floor(Math.random() * DUAS.length)];
};
